<app-button buttonType="text" icon="chevron-left" (clickit)="goBack()">Terug naar Instellingen</app-button>
<div class="header">
	<h2>Instelling toevoegen</h2>
</div>

<div class="cards">
	<div class="row">
		<div class="column">
			<div class="card">
				<div class="card-header">
					<span>Magister</span>
					<app-icon name="magister" size="large" class="right"></app-icon>
				</div>
				<app-magister-instelling-settings></app-magister-instelling-settings>
			</div>
		</div>
		<div class="column">
			<div class="card">
				<div class="card-header">
					<span>Somtoday</span>
					<app-icon name="somtoday" size="large" class="right"></app-icon>
				</div>
				<div>
					Het toevoegen van een Somtoday instelling kan door met het support account in te loggen in de desbetreffende Somtoday omgeving.
					Vervolgens kan in beheer de feature CumLaude aangezet worden. Vanaf dan zal de instelling meegenomen worden in de nachtelijke
					verwerking.
				</div>
				<a class="card-link" [href]="somtodayUrl">
					<span>Naar Somtoday</span>
					<app-icon name="new-page" color="primary-1"></app-icon>
				</a>
			</div>
		</div>
	</div>
</div>
